import * as endpoints from './endpoints';

const ChatService = { ...endpoints };

export default ChatService;
export type { ChatMessageOptions } from './endpoints';
